module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(!_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "ml-4 mt-3 tabsx",
    attrs: {
      "xs12": "",
      "sm12": "",
      "id": "tbasprint"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab1' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab1')
      }
    }
  }, [_vm._v("Audience ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab2' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab2')
      }
    }
  }, [_vm._v("Active User ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab3' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab3')
      }
    }
  }, [_vm._v("Group Pages")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab4' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab4')
      }
    }
  }, [_vm._v("Demographics")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab5' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab5')
      }
    }
  }, [_vm._v("User Explore")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab6' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab6')
      }
    }
  }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab7' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab7')
      }
    }
  }, [_vm._v("OS Uses")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab8' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab8')
      }
    }
  }, [_vm._v("Device Uses")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "primary",
      "color": _vm.currentTabs === 'tab9' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTabs('tab9')
      }
    }
  }, [_vm._v("Device Brands")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-4 mt-3",
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.exportXLX()
      }
    }
  }, [_vm._v("EXCEL")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "default"
    },
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "click", undefined, $event.key, undefined)) { return null; }
        return _vm.exportCSV()
      }
    }
  }, [_vm._v("CSV")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "click", undefined, $event.key, undefined)) { return null; }
        return _vm.exportPDF()
      }
    }
  }, [_vm._v("PDF")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-4 mt-3",
    attrs: {
      "xs7": "",
      "sm7": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Start Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "End Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab2"
    }
  }, [_c('h4', [_vm._v("Active User Overview")]), _c('br'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vue-highcharts', {
    ref: "area",
    attrs: {
      "options": _vm.chart
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab3"
    }
  }, [_c('h4', [_vm._v("Group Pages Overview")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Group Page")]), _vm._v(" "), _c('th', [_vm._v("PageViews")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab3data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _c('td', [_vm._v(_vm._s(entry[1]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab4"
    }
  }, [_c('h4', [_vm._v("Demographics Overview")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Users")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab4data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _c('td', [_vm._v(_vm._s(entry[1]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab5"
    }
  }, [_c('h4', [_vm._v("User Overview")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Number of users")]), _vm._v(" "), _c('th', [_vm._v("Session")]), _vm._v(" "), _c('th', [_vm._v("PageViews")]), _vm._v(" "), _c('th', [_vm._v("Exit Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab5data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[2]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[3]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[4]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab6"
    }
  }, [_c('h4', [_vm._v("Engagement Overview")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Session Duration")]), _vm._v(" "), _c('th', [_vm._v("Sessions")]), _vm._v(" "), _c('th', [_vm._v("PageViews")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab6data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[2]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab7"
    }
  }, [_c('h4', [_vm._v("OS Uses")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("OS")]), _vm._v(" "), _c('th', [_vm._v("Number of users")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab7data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[1]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab8"
    }
  }, [_c('h4', [_vm._v("Device Uses")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Device")]), _vm._v(" "), _c('th', [_vm._v("Number of users")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab8data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[1]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab9"
    }
  }, [_c('h4', [_vm._v("Device Brand overview")]), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped table-bordered",
    attrs: {
      "id": "hidden-table1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Device brand")]), _vm._v(" "), _c('th', [_vm._v("Number of users")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tab9data), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry[1]))])])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "tab1"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "id": "hidden-table1"
    }
  }, [_c('h4', [_vm._v("Audience Overview")]), _c('br'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vue-highcharts', {
    ref: "area",
    attrs: {
      "options": _vm.chart
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 float-leftx",
    attrs: {
      "xs12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text btn-analytics btn1",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'traffic' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('traffic')
      }
    }
  }, [_vm._v("Users (" + _vm._s(_vm.visitsc1) + ")")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics btn2",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'sessions' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('sessions')
      }
    }
  }, [_vm._v("Sessions (" + _vm._s(_vm.visitsc2) + ") ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics btn3",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'pageview' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('pageview')
      }
    }
  }, [_vm._v("PageView (" + _vm._s(_vm.visitsc3) + ")")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics btn4",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'pagesession' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('pagesession')
      }
    }
  }, [_vm._v("Page/Session (" + _vm._s(_vm.visitsc4) + ")")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics btn5",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'avgdur' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('avgdur')
      }
    }
  }, [_vm._v("Avg. Session Duration (" + _vm._s(_vm.visitsc5) + ")")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics btn6",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'bounce' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('bounce')
      }
    }
  }, [_vm._v("Bounce Rate (" + _vm._s(_vm.visitsc6) + "%)")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics btn7",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'newsession' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('newsession')
      }
    }
  }, [_vm._v("% New sessions (" + _vm._s(_vm.visitsc7) + "%)")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text btn-analytics",
    attrs: {
      "color": "primary",
      "color": _vm.currentMetric === 'newusersvsret' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeMetrics('newusersvsret')
      }
    }
  }, [_vm._v("New Users vs Returning User")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 hidden-table",
    attrs: {
      "xs12": "",
      "xs12": "",
      "sm12": "",
      "id": "hidden-table"
    }
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.exportvisits), function(entry) {
    return _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(entry[0]) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(entry[1]) + "\n        ")])])
  }), 0)])])], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "primary"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fb39e84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/gchart.vue
// module id = 1710
// module chunks = 1